// material
import { BoxProps, Container } from '@mui/material'

// ----------------------------------------------------------------------

export default function DollarSign({ sx }: BoxProps) {
  const color = sx && sx['color'] ? sx['color'] : '#000000'
  return (
    <Container sx={{ display: 'flex', padding: '0 !important' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="4.5rem" height="2.5rem" viewBox="2 -8 20 40">
        <g fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10" color={color}/>
          <path
            strokeLinecap="round"
            d="M12 6v12m3-8.5C15 8.12 13.657 7 12 7S9 8.12 9 9.5s1.343 2.5 3 2.5s3 1.12 3 2.5s-1.343 2.5-3 2.5s-3-1.12-3-2.5"
            color={color}
          />
        </g>
      </svg>
    </Container>
  )
}
